import { bootstrapApplication } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (Capacitor.isNativePlatform()) {
  document.body.classList.add('native-app');
  document.body.classList.add(`native-${Capacitor.getPlatform()}`);
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
